<ng-container *ngIf="data==='success'">
    <i class="far fa-check-circle"></i>
    <p>Your message was successfully sent</p>
</ng-container>

<ng-container  *ngIf="data==='error'">
    <i class="far fa-times-circle" ></i>
    <p>Your message wasn't sent. <br/> Please try again</p>
</ng-container>